module.exports = __webpack_public_path__ + "img/head_bg2.d0f7e274.png";